import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  DeliveryRefundDefinitionDetailDto,
  DeliveryRefundDefinitionPicklistOptionDto,
} from "src/store/contract-pickup-definition/type";
import {
  deleteDeliveryRefundDefinitionPicklistOption,
  getDeliveryRefundDefinitionDetails,
  getDeliveryRefundDefinitionPicklistOptionDetail,
  getPicklistOptionsDeliveryRefundDefinitionId,
} from "src/store/contract-pickup-definition/saga";
import OptionEditForm from "./edit";
import OptionCreateForm from "./create";

const DeliveryOptionsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<DeliveryRefundDefinitionPicklistOptionDto[]>(
    []
  );
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] =
    useState<DeliveryRefundDefinitionPicklistOptionDto>();
  const [feature, setFeature] = useState<DeliveryRefundDefinitionDetailDto>();
  const columns = [
    {
      text: t("Contract.DeliveryOption.Definition"),
      dataField: "DeliveryRefundDefinitionName",
    },
    {
      text: t("Contract.DeliveryOption.OptionName"),
      dataField: "PicklistOptionName",
    },
  ];
  useEffect(() => {
    dispatch(
      getDeliveryRefundDefinitionDetails({
        payload: {
          onSuccess: (m, p) => setFeature(p),
          onError: () => {},
        },
        id: id,
      })
    );
  }, [dispatch, id]);
  return (
    <React.Fragment>
      {feature && (
        <>
          <MainPage
            title={t("Contract.DeliveryOption.PageTitle", {
              name: feature.Name,
            })}
            metaTag={t("Contract.DeliveryOption.MetaTag", {
              name: feature.Name,
            })}
            gridProps={{
              addTitle: t("Contract.DeliveryOption.AddButton").toString(),
              listData: data,
              columns: columns,
              setDataList: setData,
              paramsid: id,
              action: getPicklistOptionsDeliveryRefundDefinitionId,
              onCreateClick: () => setShowCreate(true),
              editButton: {
                onClick: (id, data) => {
                  dispatch(
                    getDeliveryRefundDefinitionPicklistOptionDetail({
                      payload: {
                        onSuccess: (message, payload, response) => {
                          let currenctObject = payload;
                          currenctObject.Translates = response.Translates;
                          setSelected(currenctObject);
                          return setShowEdit(true);
                        },
                        onError: () => {},
                      },
                      id: id,
                    })
                  );
                },
              },
              deleteButton: {
                text: (id, data: DeliveryRefundDefinitionPicklistOptionDto) =>
                  t("Contract.DeliveryOption.DeleteQA", {
                    name: data.PicklistOptionName,
                  }),
                action: deleteDeliveryRefundDefinitionPicklistOption,
                onClick: (id, data) => setShowEdit(data),
              },
            }}
          />
          <OptionCreateForm
            open={showCreate}
            definition={feature}
            onHide={() => setShowCreate(false)}
            onSuccessClick={(m) =>
              onSuccessClickFormBasicForm({
                dispatch: dispatch,
                message: m,
                action: getPicklistOptionsDeliveryRefundDefinitionId,
                setDataList: setData,
                id: id,
              })
            }
          />
          {selected && (
            <OptionEditForm
              data={selected}
              open={showEdit}
              onHide={() => {
                setShowEdit(false);
                return setSelected(undefined);
              }}
              onSuccessClick={(m) =>
                onSuccessClickFormBasicForm({
                  dispatch: dispatch,
                  message: m,
                  action: getPicklistOptionsDeliveryRefundDefinitionId,
                  setDataList: setData,
                  id: id,
                })
              }
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default DeliveryOptionsPage;
